export const ClausePlaceholder = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6 px-10 py-8 bg-gradient-to-br from-white via-gray-50 to-gray-100 text-center">
      <div className="flex items-center justify-center rounded-full bg-blue-100 px-6 py-3 text-sm font-semibold uppercase tracking-wide text-blue-800">
        Regulation Representation
      </div>
      <div className="space-y-2 max-w-xl">
        <h2 className="text-xl font-semibold text-gray-900">
          Start exploring this regulation
        </h2>
        <p className="text-sm text-gray-600">
          Select a highlighted paragraph on the left to reveal the decision
          logic, key definitions and obligations that we derived from it.
        </p>
      </div>
      <div className="flex flex-col gap-3 rounded-2xl border border-gray-200 bg-white px-6 py-5 text-left shadow-sm max-w-md w-full">
        <div>
          <p className="text-sm font-medium text-gray-900">
            Need a place to start?
          </p>
          <p className="text-sm text-gray-500">
            Try choosing a section that is marked with colour — each hue
            represents a different type of insight.
          </p>
        </div>
        <p className="text-sm text-gray-500">
          Colours tell you what type of insight you are looking at — open the{" "}
          <button
            type="button"
            onClick={() => {
              document.dispatchEvent(new Event("openHighlightKeys"));
              document
                .getElementById("highlight-keys")
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            className="font-medium text-blue-600 hover:text-blue-500 underline"
          >
            Keys panel
          </button>{" "}
          in the top left to see what each shade means.
        </p>
        <p className="text-xs text-gray-400">
          Once selected, the representation will help you trace how that
          paragraph shapes outcomes.
        </p>
      </div>
    </div>
  );
};
